import { useState } from "react";

import Style from "./styles.module.scss";

type InfoElement = {
  title?: string | JSX.Element;
  content?: string;
  tag: string;
  image?: string;
};
const Element: React.FC<InfoElement> = ({ title, content, tag, image }) => {
  const [visibility, setVisibility] = useState(false);

  return (
    <div
      className={[
        visibility ? Style.show : Style.hide,
        tag === "img" ? Style.profileImage : Style.containerBox
      ].join(" ")}
      onMouseEnter={() => setVisibility(true)}
      onMouseLeave={() => setVisibility(false)}
      dangerouslySetInnerHTML={{
        __html:
          tag === "img"
            ? `<${tag} src=${image} />`
            : `<h5 style="text-align:center;color: #c5a5c5;">${title}</h5><${tag}>${content}</${tag}>`
      }}></div>
  );
};

export default Element;
